import type {
  EventTileCoordinates,
  RandomEventEngineState,
} from "../../models/randomEvent.ts";

export type RandomEventLifecycleNotification = {
  type: "eventTileEntered";
  eventId: string;
  tile: EventTileCoordinates;
};

export interface RandomEventTransitionResult {
  state: RandomEventEngineState;
  notifications: RandomEventLifecycleNotification[];
}

/** Emit tile-entered once when the clan steps onto the active event tile. */
export function processTileEntry(
  state: RandomEventEngineState,
  enteredTile: EventTileCoordinates,
): RandomEventTransitionResult {
  const notifications: RandomEventLifecycleNotification[] = [];
  const active = state.activeEvent;

  if (!active?.tile || active.tileEnteredEmitted) {
    return { state, notifications };
  }

  if (active.tile.q !== enteredTile.q || active.tile.r !== enteredTile.r) {
    return { state, notifications };
  }

  notifications.push({
    type: "eventTileEntered",
    eventId: active.id,
    tile: enteredTile,
  });

  return {
    state: {
      activeEvent: { ...active, tileEnteredEmitted: true },
    },
    notifications,
  };
}
